import React from 'react';
import { Link } from 'shared-components';
import { Text, Checkbox } from '@chakra-ui/react';

interface IProps {
  id: string;
  label?: string;
  blurb?: string;
  isTicked: boolean;
  checkboxLabel?: string;
  externalLink?: { link: string; text: string };
  onChange: (key: string, value: boolean) => void;
}

interface State {
  isTicked: boolean;
}

class CheckBoxQuestion extends React.Component<IProps, State> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isTicked: props.isTicked,
    };
  }

  componentDidUpdate(prevProps: IProps) {
    if (prevProps.isTicked !== this.props.isTicked) {
      this.setState({
        isTicked: this.props.isTicked,
      });
    }
  }

  onChange = () => {
    this.setState({ isTicked: !this.state.isTicked });
    this.props.onChange(this.props.id, !this.state.isTicked);
  };

  render() {
    return (
      <>
        <Text fontSize="lg" dangerouslySetInnerHTML={{ __html: this.props.blurb! }} />

        {this.props.externalLink ? (
          <Link href={this.props.externalLink.link} isExternal>
            {this.props.externalLink.text}
          </Link>
        ) : null}

        <Checkbox
          data-selector={`checkbox-label`}
          id={this.props.id}
          isChecked={this.state.isTicked}
          onChange={this.onChange}
          variant="outline"
          size="lg"
        >
          {this.props.checkboxLabel}
        </Checkbox>
      </>
    );
  }
}

export default CheckBoxQuestion;
